//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { createSlice } from '@reduxjs/toolkit';

import { SliceNames } from '@redux/SliceNames';
import { ITwitterScheduleModalState } from '@twitter/redux/schedule/modals/twitterScheduleModalModel';

const initialState: ITwitterScheduleModalState = {
  isPostDeletedModalOpen: false,
};

const { actions, reducer } = createSlice({
  name: SliceNames.TwitterScheduleModals,
  initialState,
  reducers: {
    openPostDeletedModal(state) {
      state.isPostDeletedModalOpen = true;
    },
    closePostDeletedModal(state) {
      state.isPostDeletedModalOpen = false;
    },
  },
});

export const { openPostDeletedModal, closePostDeletedModal } = actions;

export default reducer;
